module.exports = __webpack_public_path__ + "images/emoji/wedding.d499b36ec0d96391f40b.png";